import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Params, ActivatedRoute , RouterModule } from '@angular/router';
import { DocumentsDataService } from '../../../../../_services/data-services/documents-data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Location } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent],
  selector: 'app-load-documents',
  templateUrl: './load-documents.component.html',
  styleUrls: ['./load-documents.component.scss'],
})
export class LoadDocumentsComponent implements OnInit {
  documentId: string;
  loading: boolean;
  fileName: string;
  policyURL: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private documentsDataService: DocumentsDataService,
    private sanitizer: DomSanitizer,
    private location: Location
  ) {}

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe((params: Params) => {
      this.documentId = params['documentId'];
    });
  }
}
